import Vue from 'vue'

export default {
  get (slug) {
    if (slug) {
      return Vue.http.get('articles/slug/' + slug)
    } else {
      return Vue.http.get('articles?lang=' + Vue.config.lang)
    }
  },
  getByType (type) {
    return Vue.http.get('articles/type/' + type + '?lang=' + Vue.config.lang)
  },
  getForId (id) {
    return Vue.http.get('articles/' + id + '?lang=' + Vue.config.lang)
  },
  search (query) {
    return Vue.http.post('articles/search?lang=' + Vue.config.lang, { query: query })
  }
}



// WEBPACK FOOTER //
// ./src/services/ArticlesService.js